import Reveal from '../components/site/Reveal';
import SectionHeader from '../components/site/SectionHeader';
import { SERVICES } from '../data/site';
import { Check } from 'lucide-react';

export default function Services() {
  return (
    <div data-testid="page-services">
      <section className="pt-40 pb-16">
        <div className="max-w-[1400px] mx-auto px-6 md:px-10 lg:px-16">
          <Reveal>
            <p className="eyebrow mb-6">— What We Do</p>
            <h1 className="font-display text-5xl md:text-7xl lg:text-[88px] leading-[0.95] tracking-tighter text-prim max-w-4xl">
              Four mandates,<br/>one operating discipline.
            </h1>
            <p className="mt-8 text-sec text-lg md:text-xl max-w-3xl leading-relaxed">
              From ecosystem architecture to venture-as-a-service, performance turnarounds and enterprise-grade digital transformation — our work begins where conventional advisory ends.
            </p>
          </Reveal>
        </div>
      </section>

      <section className="py-16 border-t border-subtle">
        <div className="max-w-[1400px] mx-auto px-6 md:px-10 lg:px-16 space-y-6">
          {SERVICES.map((s, i) => (
            <Reveal key={s.number} delay={i * 80}>
              <div data-testid={`service-${s.number}`} className="border border-subtle surface-2 rounded-md card-glow overflow-hidden">
                <div className="grid grid-cols-1 lg:grid-cols-12 gap-0">
                  <div className="lg:col-span-1 p-8 md:p-10 bg-gradient-to-br from-brand-maroon/20 to-transparent border-r border-subtle">
                    <p className="font-display text-6xl text-brand-teal-light tracking-tighter">{s.number}</p>
                  </div>
                  <div className="lg:col-span-7 p-8 md:p-10 border-r border-subtle">
                    <h3 className="font-display text-3xl md:text-4xl text-prim tracking-tight leading-tight">{s.title}</h3>
                    <p className="mt-4 text-sec leading-relaxed text-lg">{s.blurb}</p>
                  </div>
                  <div className="lg:col-span-4 p-8 md:p-10">
                    <p className="eyebrow mb-5">Capabilities</p>
                    <ul className="space-y-3">
                      {s.bullets.map((b) => (
                        <li key={b} className="flex items-start gap-3 text-sec">
                          <Check size={16} className="mt-1 text-brand-teal-light shrink-0" />
                          <span>{b}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </section>
    </div>
  );
}
